import { useEffect, useState } from "react";

function remainingSec(startedAt: string | null, total: number): number {
  if (!startedAt) return total;
  const start = new Date(startedAt).getTime();
  if (Number.isNaN(start)) return total;
  return Math.max(0, total - (Date.now() - start) / 1000);
}

/**
 * Per-pick countdown. Synced across all viewers via the server's pickStartedAt
 * timestamp, but ticks locally every second so it's smooth between polls.
 */
export function PickClock({
  startedAt,
  seconds,
  size = "md",
}: {
  startedAt: string | null;
  seconds: number;
  size?: "md" | "lg";
}) {
  const [rem, setRem] = useState(() => remainingSec(startedAt, seconds));

  useEffect(() => {
    setRem(remainingSec(startedAt, seconds));
    const id = setInterval(() => setRem(remainingSec(startedAt, seconds)), 250);
    return () => clearInterval(id);
  }, [startedAt, seconds]);

  const whole = Math.ceil(rem);
  const label = `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, "0")}`;
  const expired = rem <= 0;
  const urgent = rem <= 10 && !expired;
  const color = expired ? "text-loss" : urgent ? "text-clock" : "text-fg";
  const cls = size === "lg" ? "text-7xl" : "text-4xl";

  return (
    <div className="flex flex-col items-center leading-none">
      <span
        className={`num font-black tabular ${cls} ${color} ${urgent ? "animate-pulseclock" : ""}`}
      >
        {expired ? "0:00" : label}
      </span>
      <span className="mt-1 text-[10px] font-semibold uppercase tracking-widest text-faint">
        {expired ? "time!" : "pick clock"}
      </span>
    </div>
  );
}
